import styles from './style.postcss';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import is from 'is_js';
import { TextArea } from 'omni-common-ui';

class Item extends PureComponent {

  render() {
    const {
      isEdit,
      title,
      value,
      onChange,
      className,
      isWithoutBottomLine,
      description,
    } = this.props;
    const itemClassName = classnames(styles.FeedbackItem, className, {
      [styles.__withoutBottomLine]: isWithoutBottomLine,
    });
    return <div className={itemClassName}>
      <h6 className={styles.FeedbackItem_title}>{title}</h6>
      {
        isEdit ?
          <TextArea className={styles.FeedbackItem_textarea}
              value={value}
              onChange={(e) => onChange(e.target.value)} /> :
          <pre className={styles.FeedbackItem_view}>{value}</pre>
      }
      {is.string(description) ?
        <p className={styles.FeedbackItem_description}>
          {description}
        </p> : null }
    </div>;
  }
}

Item.propTypes = {
  description: PropTypes.string,
  isWithoutBottomLine: PropTypes.bool,
  title: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string,
  isEdit: PropTypes.bool,
  className: PropTypes.string,
};

export default Item;



// WEBPACK FOOTER //
// ./containers/Group/SessionReport/Feedback/Item/index.jsx